
import { Component, Vue } from "vue-property-decorator";
import OrderPane from "../components/order-pane.vue";
import DatePicker from "@/components/date-picker.vue";
import {
  apiReturnOrderList,
  apiReturnOrderExpressField,
  apiTransferLogList,
  apiSetCustomInfo,
} from "@/api/order";
import ExportData from "@/components/export-data/index.vue";
import { RequestPaging } from "@/utils/util";
import LsPagination from "@/components/ls-pagination.vue";
import { apiShopLists } from "@/api/shop";
@Component({
  components: {
    OrderPane,
    DatePicker,
    ExportData,
    LsPagination,
  },
})
export default class ReturnOrder extends Vue {
  // S Data
  apiReturnOrderList = apiReturnOrderList;
  pager = new RequestPaging();
  loading = false;
  form: any = {
    sn: "", //否	string	订单信息
    sid: "", //否	string	下单商户
    to_sid: "", //否	string	工厂商户
    start_time: "", //否	string	开始时间
    end_time: "", //否	string	结束时间
    status: "",
    settlement_status: 0,
    express_main_status: [],
    register_status: "",
    express_update_time: "",
  };
  selectedArr: any[] = [];
  shop_lists: any[] = [];
  statusList = [
    { value: "", label: "全部" },
    { value: 0, label: "未进行" },
    { value: 1, label: "已执行" },
    { value: 2, label: "执行错误" },
    { value: 3, label: "订单取消" },
  ];
  settlementList = [
    { value: 0, label: "全部" },
    { value: 1, label: "已结算" },
    { value: 2, label: "待结算" },
    { value: 3, label: "待完成（未出库）" },
    { value: 4, label: "结算失败" },
  ];
  dialogVisible = false;
  logList: any[] = [];
  expressLogList: any[] = [];
  expressDialogVisible = false;
  time: Array<object> = [];
  pickerOptions = {
    shortcuts: [
      {
        text: "最近一周",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近一个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit("pick", [start, end]);
        },
      },
      {
        text: "最近三个月",
        onClick(picker: any) {
          const end = new Date();
          const start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit("pick", [start, end]);
        },
      },
    ],
  };

  deliveryStatusList = [
    { value: "Not", label: "未注册" },
    { value: "NotFound", label: "查询不到" },
    { value: "InfoReceived", label: "收到信息" },
    { value: "InTransit", label: "运输途中" },
    { value: "Expired", label: "运输过久" },
    { value: "AvailableForPickup", label: "到达待取" },
    { value: "OutForDelivery", label: "派送途中" },
    { value: "DeliveryFailure", label: "投递失败" },
    { value: "Delivered", label: "成功签收" },
    { value: "Exception", label: "可能异常" },
  ];
  logisticsStatus: any = {
    NotFound: {
      icon: require("@/assets/images/logistics/NotFound.png"),
      color: "#727272",
      title: "查询不到",
    },
    InfoReceived: {
      icon: require("@/assets/images/logistics/InfoReceived.png"),
      color: "#00BCD4",
      title: "收到信息",
    },
    InTransit: {
      icon: require("@/assets/images/logistics/InTransit.png"),
      color: "#2196F3",
      title: "运输途中",
    },
    Expired: {
      icon: require("@/assets/images/logistics/Expired.png"),
      color: "#CA402A",
      title: "运输过久",
    },
    AvailableForPickup: {
      icon: require("@/assets/images/logistics/AvailableForPickup.png"),
      color: "#0D47A1",
      title: "到达待取",
    },
    OutForDelivery: {
      icon: require("@/assets/images/logistics/OutForDelivery.png"),
      color: "#2962FF",
      title: "派送途中",
    },
    DeliveryFailure: {
      icon: require("@/assets/images/logistics/DeliveryFailure.png"),
      color: "#E86548",
      title: "投递失败",
    },
    Delivered: {
      icon: require("@/assets/images/logistics/Delivered.png"),
      color: "#43A047",
      title: "成功签收",
    },
    Exception: {
      icon: require("@/assets/images/logistics/Exception.png"),
      color: "#FF7D00",
      title: "可能异常",
    },
  };
  fieldList: any[] = [];
  //注册物流单号状态
  registerStatusList = [
    { value: 0, label: "未注册" },
    { value: 1, label: "注册成功" },
    { value: 2, label: "注册失败" },
  ];
  expressFieldList: any[] = [];
  activeTab = "";
  expressStatusDialogVisible = false;

  customInfo: any = [];
  customStatusContent = "";
  // E Data

  // S Methods

  // 获取订单信息
  getShopList() {
    apiShopLists({ page_size: 9999 }).then((res) => {
      this.shop_lists = res.lists;
    });
  }
  getList(page?: number) {
    this.loading = true;
    page && (this.pager.page = page);
    this.pager
      .request({
        callback: apiReturnOrderList,
        params: {
          // order_status: status,
          ...this.form,
        },
      })
      .then((res) => {
        this.loading = false;
      });
  }
  handleSelectionChange(val: any) {
    this.selectedArr = val.map((item: any) => item.id);
  }
  getDeliveryStatus(status: string) {
    const data: any = this.logisticsStatus[status];
    return data
      ? `<div class="flex col-center">物流状态：<img src="${data.icon}" style="width: 20px; height: 20px;margin-right: 5px;" alt="${data.title}" /><span style="color: ${data.color};">${data.title}</span></div>`
      : "物流状态：无";
  }
  // 获取注册物流单号状态
  getRegisterStatus(status: number) {
    if (!status) {
      return "未注册";
    }
    return (
      this.registerStatusList.find((item) => item.value == status)?.label || ""
    );
  }
  showExpressDialog(value: any) {
    this.expressLogList = value?.track || [];
    this.expressDialogVisible = true;
  }
  splitTime() {
    if (this.time != null) {
      this.form.start_time = this.time[0];
      this.form.end_time = this.time[1];
    }
  }
  // 重置搜索
  reset() {
    Object.keys(this.form).map((key) => {
      this.$set(this.form, key, "");
    });
    this.getList(1);
  }

  showDialog(id: number) {
    this.dialogVisible = true;
    apiTransferLogList({ id: id, page_size: 9999 }).then((res) => {
      this.logList = res.lists;
    });
  }

  async getExpressField() {
    const res = await apiReturnOrderExpressField({});
    let fieldList: any = [];
    res.forEach((item: any, index: number) => {
      item.id = item.id || index + 1 + "";
      item.where.map((where: any) => {
        fieldList.push(where.field);
      });
    });
    this.fieldList = [...new Set(fieldList)];
    
    res.unshift({
      name: "全部",
      count: "",
      where: [],
      id: "",
    });
    this.expressFieldList = res;
  }

  handleClick(tab: any) {
    const index = tab.index;
    const item = this.expressFieldList[index];
    this.activeTab = item.id;
    for (let field of this.fieldList) {
      this.form[field] = "";
    }
    if (item.where.length > 0) {
      item.where.map((where: any) => {
        this.form[where.field] = where.value;
      });
    }
    this.getList(1);
  }

  showExpressStatusDialog(value: any) {
    this.customInfo = [{ t_id: value.t_id }];
    this.customStatusContent = value.custom_status || "";
    this.expressStatusDialogVisible = true;
  }

  expressStatusDialogBeforeClose() {
    this.customStatusContent = "";
  }

  expressStatusSubmit() {
    let data = this.customInfo;
    data[0].custom_status = this.customStatusContent;
    apiSetCustomInfo({ data: data }).then((res: any) => {
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.expressStatusDialogVisible = false;
      this.getList(1);
    });
  }
  // E Methods

  // S  life cycle

  async created() {
    await this.getExpressField();
    this.getShopList();
    // 获取订单信息
    this.getList();
  }

  // E life cycle
}
